import preferences from "@coworker/enums/profilePreferences";
import { useUserPreferenceStoreFilterValues } from "@coworker/apprestructured/src/shared/filters/utils/store/useUserPreferenceStoreFilterValues";
import { usePeriodFilter } from "../../MFAQ/hooks/usePeriodFilter";
import { FilterValue } from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useLocationFilter } from "./useLocationFilter";

export function useTestBuyFilters() {
  const { filterValues, setFilterValues } = useUserPreferenceStoreFilterValues(
    preferences.TESTBUY_FILTERS
  );

  const useTestBuyDataFilters = (filterValues: FilterValue[]) => [
    usePeriodFilter(filterValues),
    useLocationFilter(),
  ];

  return {
    useFiltersFactory: useTestBuyDataFilters,
    filterValues,
    setFilterValues,
  };
}
